import React, { useEffect, useState } from "react";
import TopNav from "../../Components/Dashboards/TopNav";
import Notifications from "../../Components/Dashboards/Notifications";
import NavHeader2 from "../../Components/Dashboards/NavHeader2";
import Sidebar from "../../Components/Dashboards/Sidebar";
import Footer from "../../Components/Dashboards/Footer";
import BreadcrumTop from "../../Components/Dashboards/BreadcrumTop";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import "../../Components/Dashboards/../../libs/css/dataTable.css";
import Spinner from "../../Components/Dashboards/../../Spinner/Spinner";
import Nulls from "../../Components/Dashboards/Nulls";
import { useProducts } from "../../hooks/useProducts";
import Swal from "sweetalert2";
import { API_ROUTES } from "../../utils/constants";
import { getToken } from "../../utils/getToken";
import { useQueryClient } from "@tanstack/react-query";

export default function ListOfProducts(props) {
  const { isLoaded, capitalizeWords } = props;
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [loginUserRole, setLoginUserRole] = useState("");
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // Use React Query hook
  const { data: products = [], isLoading, isError, error } = useProducts();

  useEffect(() => {
    document.title = "Products | Dashboard";
  }, []);

  // Check user role
  useEffect(() => {
    const storedUserData = localStorage.getItem("userVASData");
    if (storedUserData) {
      try {
        const parsedData = JSON.parse(storedUserData);
        const userRoles = parsedData.responseDetails?.roles;

        if (userRoles && userRoles.length > 0) {
          setLoginUserRole(userRoles[0]);
        }
      } catch (error) {
        console.error("Error parsing storedUserData:", error);
      }
    }
  }, []);

  // Redirect if not Admin
  useEffect(() => {
    if (loginUserRole && loginUserRole !== "Admin") {
      navigate("/dashboard/company");
    }
  }, [loginUserRole, navigate]);

  // Columns definition
  const columns = [
    {
      name: "Product Name",
      selector: (row) => (row.name ? row.name : <Nulls />),
      sortable: true,
    },
    {
      name: "Product ID",
      selector: (row) => (row.productId ? row.productId : <Nulls />),
      sortable: true,
    },
    {
      name: "Marketer",
      selector: (row) => (row.marketerName ? row.marketerName : <Nulls />),
      sortable: true,
    },
    {
      name: "Company",
      selector: (row) => (row.companyName ? row.companyName : <Nulls />),
      sortable: true,
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
    },
    {
      name: "Running",
      selector: (row) => row.running,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) =>
        row.createdAt ? (
          new Date(row.createdAt).toLocaleDateString()
        ) : (
          <Nulls />
        ),
      sortable: true,
    },
  ];

  const ActivateProduct = async (formData) => {
    console.log("formData", formData);
    const token = getToken();
    if (!token) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ROUTES.ACTIVATE_PRODUCT, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      // if (responseJSON) {
      //   const sortedData = responseJSON;

      // } else {
      //   console.error("Unexpected response format:", responseJSON);
      // }
      //  console.log("response data from api ", responseJSON);

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: responseJSON.message || "Activation successful",
          icon: "success",
        });
       
        queryClient.invalidateQueries({ queryKey: ["products"] });
      } else {
        Swal.fire({
          title: "Error",
          text: responseJSON.message || "An unexpected error occured",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error Activating product:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Expandable row
  const ExpandedComponent = ({ data }) => (
    <div className="text-left th_data mt-3 pb-4">
      <div>
        <font>Action: &nbsp;&nbsp; </font>
        <span style={{ textTransform: "uppercase" }}>
          <Link
            to="/products/update"
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6a73fa",
              border: "none",
              color: "#fff",
              padding: "8px 10px",
              borderRadius: "6px",
            }}
            className="mx-2"
          >
            Update Product
          </Link>
          <Link
            to="/products/delete"
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "red",
              border: "none",
              color: "white",
              padding: "8px 10px",
              borderRadius: "6px",
            }}
            className="mx-1"
          >
            Delete Product
          </Link>
          <button
            className="mx-1"
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: `${data.running == "yes" ? "red" : "blue"}`,
              border: "none",
              color: "white",
              padding: "8px 10px",
              borderRadius: "6px",
            }}
            onClick={() => handleActivateorDeactivate(data)}
          >
            {data.running == "yes" ? "pause" : "resume"}
          </button>
        </span>
      </div>
    </div>
  );
  const handleActivateorDeactivate = async (data) => {
    const data2Send = {
      productId: data.productId,
      marketerId: data.marketerId,
      companyId: data.companyId,
      status: data.running === "yes" ? "no" : "yes",
    };
    await ActivateProduct(data2Send);
  };
  // Filter
  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = products.filter((product) => {
    return (
      product.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      product.productId?.toLowerCase().includes(filterText.toLowerCase())
    );
  });

  if (!loginUserRole) {
    return <Spinner loading={true} />;
  }

  return (
    <>
      {loginUserRole === "Admin" ? (
        <div id="main-wrapper" className={isLoaded ? "show" : ""}>
          <TopNav />
          <Notifications />
          <NavHeader2 />
          <Sidebar />

          <div className="content-body mt--10">
            <div className="container-fluid pl-xs-0 pr-xs-0 pt-xs-0">
              <BreadcrumTop title="Products" />

              <div className="row">
                <div className="container d-flex justify-content-end align-items-center mb-4">
                  <div className="col-md-5 col-sm-12 mx-1 d-flex justify-content-end">
                    <input
                      type="text"
                      placeholder="Enter Product Name or ID"
                      value={filterText}
                      onChange={handleFilterChange}
                      className="form-control"
                    />
                    <div className="col-md-5 col-sm-12 mx-1">
                      <Link to="/products/create" className="btn btn-primary">
                        Create Product
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {isLoading || loading ? (
                  <Spinner loading={isLoading || loading} />
                ) : isError ? (
                  <div className="alert alert-danger" role="alert">
                    Error loading products: {error?.message}
                  </div>
                ) : (
                  <DataTable
                    className="services_datatable display text-nowrap"
                    title=""
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    columns={columns}
                    data={filteredData}
                    highlightOnHover
                    pagination
                    paginationPerPage={20}
                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                  />
                )}
              </div>
            </div>
          </div>

          <Footer />
        </div>
      ) : (
        <div className="text-primary">You don't have access to this page.</div>
      )}
    </>
  );
}
